/**
 * A control that goes somewhere, drawn as a button (plan 1b final review): a react-router
 * Link with the Button's look (`buttonVariants`: the same `variant` and `size`, the default
 * size 44 px on coarse pointers, the focus ring). It stays a link, never role="button": a
 * screen reader says it leads somewhere, and it opens in a new tab like any link. A caller
 * that names it with `aria-label` starts that name with the visible words.
 */
import type { VariantProps } from 'class-variance-authority'
import { Link, type LinkProps } from 'react-router'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type TautanTombolProps = LinkProps & VariantProps<typeof buttonVariants>

export function TautanTombol({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: TautanTombolProps) {
  return (
    <Link
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}
